import angular from 'angular';
import {ZendeskService} from './zendesk-strategy.service';

angular
  .module('parameters.zendesk', [])
  .factory('ZendeskFactory', ZendeskService.ZendeskFactory)
